import { getSessionStorageItem } from '@utilities/helpers/storage.helper';
import type { PasskeyThirdPartyPayload } from '@shared/models';

export interface PasskeyRegisterHandoff {
  ceremonyId: string;
  optionsJson: string;
}

const HANDOFF_STORAGE_PREFIX = 'passkey:handoff:';

export const buildHandoffStorageKey = (handoffKey: string): string => `${HANDOFF_STORAGE_PREFIX}${handoffKey}`;

export const readRegisterHandoffFromStorage = (handoffKey: string): PasskeyRegisterHandoff | undefined => {
  try {
    const raw = getSessionStorageItem(buildHandoffStorageKey(handoffKey));
    if (!raw) {
      return undefined;
    }

    const parsed = JSON.parse(raw) as Partial<PasskeyRegisterHandoff>;
    if (!parsed.ceremonyId || !parsed.optionsJson) {
      return undefined;
    }

    return {
      ceremonyId: parsed.ceremonyId,
      optionsJson: parsed.optionsJson,
    };
  } catch {
    return undefined;
  }
};

export const resolveRegisterHandoff = (
  payload: Pick<PasskeyThirdPartyPayload, 'ceremonyId' | 'optionsJson' | 'optionsHandoffKey'>,
): PasskeyRegisterHandoff | undefined => {
  if (payload.ceremonyId && payload.optionsJson) {
    return {
      ceremonyId: payload.ceremonyId,
      optionsJson: payload.optionsJson,
    };
  }

  if (payload.ceremonyId && payload.optionsHandoffKey) {
    const stored = readRegisterHandoffFromStorage(payload.optionsHandoffKey);
    if (stored && stored.ceremonyId === payload.ceremonyId) {
      return stored;
    }
  }

  return undefined;
};
